// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"700":"510c693e","3162":"64810c9a","8579":"daa979eb","8688":"b03147d3","9369":"605f0f51"}[chunkId] + ".chunk.css";
};